/**
 *
 *   se_category  what kind of thing
 *   se_action    what happened to it
 *   se_label     which one
 *   se_property  which variant
 *   se_value     how many — the only slot the warehouse types as a number
 *
 * Only category and action are required; a slot left undefined is omitted from
 * the event rather than sent empty. Slots are sent exactly as the mapper builds
 * them — snowplowTarget does not coerce or validate, because this is a
 * like-for-like port of the GTM tags.
 */
/**
 * `setUserId` is not a slot. It is the optional extra line the GTM Login tag runs
 * before its struct event — snowplow('setUserId', ...) — which makes every later
 * event on the page carry the id. Only Login uses it.
 */
const struct = ({
  category, action, label, property, value, setUserId,
}) => ({
  event: 'struct',
  category,
  action,
  label,
  property,
  value,
  setUserId,
});

export default struct;
